(function() {
    'use strict';
    
a3_cabin_reports.factory('CabinReportRestoreFactory',CabinReportRestoreFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CabinReportRestoreFactory
    * @description 
    *   Manage Local Cabin Reports.
    * @ngInject
    */
    function CabinReportRestoreFactory(localStorageMD5Service, FlightFactory, CabinReportLocalEditFactory,IndexedDBService) {

        var IdxType = 'Reports';

        
        var service = {
                    getReportsFromIdx : getReportsFromIdx,
                    setReportsToIdx : setReportsToIdx,
                    updateReportToIdx : updateReportToIdx,
                    addReportToIdx : addReportToIdx,
                    deleteReportFromIdx : deleteReportFromIdx,
                    clearReportsFromIdx :clearReportsFromIdx,
                    getReportsFromLs : getReportsFromLs,
                    backUpReports : backUpReports,
                    restoreReports : restoreReports
                }

        /**
         * Get Reports
         * @memberof CabinReportRestoreFactory
         * @param {function} callback  
         */
        function getReportsFromIdx(callback) {
            //return GenericService.list(Idx,objCallback);
            IndexedDBService.getAll(IdxType).then(function (results) {
                callback(results);
            });
        };

        /**
         * Set Reports
         * @memberof CabinReportRestoreFactory
         * @param {array} Reports   a list of Reports to set to indexedDB
         */
        function setReportsToIdx(Reports) {
            IndexedDBService.addAll(IdxType, Reports);
        };

        /**
         * Update Report to Storage
         * @memberof CabinReportRestoreFactory
         * @param {object} Report   a Report
         */
        function updateReportToIdx(Report) {
            IndexedDBService.put(IdxType, Report);
        };

         function info(){
            IndexedDBService.info(IdxType);
         }

        /**
         * Add Report to Storage
         * @memberof CabinReportRestoreFactory
         * @param {object} Report   a Report
         */
        function addReportToIdx(Report) {
            IndexedDBService.add(IdxType, Report);
        };

        /**
         * Delete Report from Storage
         * @memberof CabinReportRestoreFactory
         * @param {number} RerportGuid  The unique Identifier of the Report
         */
        function deleteReportFromIdx(ReportId) {
            IndexedDBService.remove(IdxType, ReportId);
        };

        /**
         * Clear Report from Storage
         * @memberof CabinReportRestoreFactory
         */
        function clearReportsFromIdx() {
            IndexedDBService.removeAll(IdxType);
        };


        /**
         * Get Cabin Reports from storage
         * @memberof CabinReportLocalEditFactory
         * @returns {Array} CabinReports
         */
		function getReportsFromLs() {     
			return  localStorageMD5Service.get('cabinReportLocalEdits');
		}

        /**
         * Get reports from IndexedDB and delete the reports that have been stored
         * @memberof CabinReportRestoreFactory
         */
        function getReportsFromIdxDeleteStoredReports(callback){
            var reportsIdx = [];
            var storedReportsLs = FlightFactory.getFlightsWithStoredReport();
            getReportsFromIdx(function (results){
                for(var i=0; i<results.length; i++){
                    var isStored = storedReportsLs.some(function (item) {
                        return  results[i].FlightId == item.FlightId && item.cabinReportStatusDescr == "Stored";
                    });
                    if(isStored){
                        deleteReportFromIdx(results[i].FlightId);
                    }
                    else{
                        reportsIdx.push(results[i]);
                    }
                }
                callback(reportsIdx);
            });

        }

        /**
         * Back up reports. Gets the reports from localstorage and save them to IndexedDB. 
         * Steps:
         * 1. Clear IndexedDB from reports which have been stored
         * 2. Replace the existing reports
         * 3. Insert if not existing
         * @memberof CabinReportRestoreFactory
         */
		function backUpReports() {
			//1
            //Get reports from indexedDB, check each of them if is existed at the StroredReport list
            getReportsFromIdxDeleteStoredReports(function (reportsIdx){
            //2
            //Foreach report in the local storage, save to indexedId, if existed need to be replaced 
            //get reports from localStorage
                var reportsAll = [];
                reportsAll = getReportsFromLs();
                if(reportsAll && reportsAll.length>0){
                    for(var i=0; i< reportsAll.length; i++){
                        var reportLs = reportsAll[i];
                        var isExisting = reportsIdx.some(function (item) {
                                return  reportLs.FlightId == item.FlightId;
                            });
                        if(isExisting){
                            //Replace the report
                            deleteReportFromIdx(reportLs.FlightId);
                            addReportToIdx(reportLs);
                        }
                        else{
                            //Insert the report
                            addReportToIdx(reportLs);
                        }
                    }
                }

            });

		}

         /**
         * Restore reports. Compares the reports from localstorage and from IndexedDB, and it inserts the reports that are missing from local storage. 
         * Steps:
         * 1.
         * @memberof CabinReportRestoreFactory
         * @returns {array} list of flightNo foreach restored report 
         */
		function restoreReports(callback) {
			getReportsFromIdxDeleteStoredReports(function (reportsIdx){
                var results = [];
                var reportsAll = [];
                reportsAll = getReportsFromLs();
                for(var i=0; i< reportsIdx.length; i++){
                    //Check if exists
                    var isExisting = reportsAll.some(function (item) {
                            return  reportsIdx[i].FlightId == item.FlightId 
                                    && (reportsIdx[i].Status == "draft" || reportsIdx[i].Status == "completed");
                        });
                    if(isExisting){
                        //Delete existing reports
                        deleteReportFromIdx(reportsIdx[i].FlightId);
                    }
                    else{
                        //Insert reports that are not existed
                        var extendReport = CabinReportLocalEditFactory.fromObject(reportsIdx[i]);
                        extendReport.Status = "draft";
                        extendReport.saveReport();
                        FlightFactory.updateFlightFromReport(extendReport);

                        //Then delete from indexed db
                        deleteReportFromIdx(reportsIdx[i].FlightId);
                        results.push(reportsIdx[i].FlightNo );
                    }
                }
                callback(results);
            });
		}

		return service;
	}

})();